import { useLazyQuery } from "@apollo/client";
import { DefaultInfo } from "components/NothingRight";
import Table from "components/Table";
import { ROW_PER_PAGE_OPTIONS } from "config";
import useText from "constants/text";
import { AdvantageDemand } from "generated/graphql";
import { GET_DEMANDES_BY_CLIENT } from "graphql/Fidelity/queries";
import { useCurrentClient } from "hooks";
import React, { FC, useEffect, useState } from "react";
import { isSuccess } from "utils/https";
import Banner from "../components/Banner";
import Header from "../components/Header";
import { usProgramColums } from "../data";
import { FidelityLayout } from "../style";

const ProgramHistory: FC = (props) => {
  const { text } = useText();
  const columns = usProgramColums(text);
  const [demands, setDemands] = useState<AdvantageDemand[]>([]);
  const [countTotal, setCountTotal] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = useState<number>(0);

  const { client } = useCurrentClient();
  const [getClientDemands, getClientDemandData] = useLazyQuery(GET_DEMANDES_BY_CLIENT, { fetchPolicy: "network-only" });
  useEffect(() => {
    client &&
      getClientDemands({
        variables: {
          id: client?._id,
          queries: {
            limit: rowsPerPage,
            page: page + 1,
          },
        },
      });
  }, [rowsPerPage, page, client]);
  useEffect(() => {
    if (isSuccess(getClientDemandData?.data)) {
      setDemands(getClientDemandData?.data?.results?.data);
      setCountTotal(getClientDemandData?.data?.results?.countTotal);
    }
  }, [getClientDemandData?.data]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  return (
    <FidelityLayout>
      <div className="container">
        <div className="left">
          <Header />
          <div className="card-container">
            <Banner title={text.fidelity_program.fidelity_history_title} />

            <Table
              tableHeight="49vh"
              rowsIdentifier="_id"
              columns={columns}
              data={demands || []}
              rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
              rowsPerPage={rowsPerPage}
              currentPage={page}
              countTotal={countTotal}
              setRowsPerPage={setRowsPerPage}
              onChangePage={handleChangePage}
              isLoading={getClientDemandData?.loading}
            />
          </div>
        </div>
        <div className="right">
          <DefaultInfo />
        </div>
      </div>
    </FidelityLayout>
  );
};

export default ProgramHistory;
